import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Error from "../../../ErrorPages/Error";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";

const ReturnedSlipDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { useFetch: useFetchReturnedSlip } = useAPIQuery({
        key: "/api/return/slip/all/",
        endpoint: "/api/return/slip/all/",
    });
    const {
        data: returnedSlips,
        isLoading: returnedSlipsLoading,
        isFetching: returningSlipsFetching,
        isError: errorLoadingDailyPlans,
    } = useFetchReturnedSlip({
        params: {
            date: location?.state?.data?.date,
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    const columns = [
        {
            accessor: "item",
            header: "Item",
            cell: (row) => (
                <span>
                    {row?.requisition_rm?.item
                        ? row?.requisition_rm?.item
                        : row?.requisition_wip?.item}
                </span>
            ),
        },
        {
            accessor: "requisition_code",
            header: "Requisition Code",
            cell: (row) => (
                <span>
                    {row?.requisition_rm?.requisition_code
                        ? row?.requisition_rm?.requisition_code
                        : row?.requisition_wip?.requisition_code}
                </span>
            ),
        },
        {
            accessor: "batch_code",
            header: "Batch Code",
            cell: (row) => (
                <span>
                    {row?.requisition_rm?.batch_code
                        ? row?.requisition_rm?.batch_code
                        : row?.requisition_wip?.batch_code}
                </span>
            ),
        },
        {
            accessor: "requested_quantity",
            header: "Requested Quantity",
            cell: (row) => (
                <span>
                    {row?.requisition_rm?.requested_quantity
                        ? row?.requisition_rm?.requested_quantity
                        : row?.requisition_wip?.requested_quantity}
                </span>
            ),
        },
        {
            accessor: "received_quantity",
            header: "Received Quantity",
            cell: (row) => (
                <span>
                    {row?.requisition_rm?.received_quantity
                        ? row?.requisition_rm?.received_quantity
                        : row?.requisition_wip?.received_quantity}
                </span>
            ),
        },
        {
            accessor: "returned_quantity",
            header: "Returned Quantity",
        },
    ];

    if (errorLoadingDailyPlans) return <Error />;
    return (
        <Fragment>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">
                            Return Slip ({location?.state?.data?.date})
                        </h4>
                    </div>
                    <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <Table
                        data={returnedSlips?.results?.data ?? []}
                        columns={columns}
                        isLoading={
                            returnedSlipsLoading || returningSlipsFetching
                        }
                        globalSearch={false}
                        pagination={false}
                        manualFilter={false}
                        manualSorting={false}
                        editRows={false}
                        deleteRows={false}
                        filterModal={false}
                        selectRows={false}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default ReturnedSlipDetails;
